import axios from 'axios'
import moment from 'moment'
import { cloneDeep, isEmpty } from 'lodash'
import { months } from '@/helpers/date'

const state = {
  helpers: {
    //startYear: '2016',
    startYear: moment().subtract(2, 'years').format('YYYY'),
    endYear: moment().add(1, 'years').format('YYYY'),
    months: months,
  },
  params: {
    level: null, // lt, sc
    year: null,
    month: null,
    item: '1'
  },
  dateRange: [],
  table: []
}

const getters = {
  params: (state) => {
    return state.params
  },
  dateRange: (state) => {
    return state.dateRange
  },
  table: (state) => {
    return state.table
  }
}

const actions = {
  selectLevel ({ commit, dispatch }, { level }) {
    commit('setLevel', { level })
    dispatch('fetchResources')
  },

  selectDate ({ commit, dispatch }, { year, month }) {
    commit('setDate', {
      year: year.toString(),
      month: month.toString()
    })
    dispatch('fetchResources')
  },

  selectItem ({ commit, dispatch }, { item }) {
    commit('setItem', {
      item: item
    })
    dispatch('fetchResources')
  },

  // 產生全部時間範圍
  setDateRange ({ state, commit }) {
    let dateRange = []
    let monthItems = state.helpers.months
    let start = parseInt(state.helpers.startYear)
    let end = parseInt(state.helpers.endYear)

    for (let i = start; i <= end; i++) {
      let year = {
        value: i.toString(),
        label: i.toString(),
        disabled: true,
        children: []
      }

      for (let j = 0; j < 12; j++) {
        let month = cloneDeep(monthItems[j])
        month.disabled = true

        year.children.push(month)
      }

      dateRange.push(year)
    }

    commit('setDateRange', dateRange)
  },

  // 更新使用者可選之時間
  setDateRangeAvailable ({ state, commit }, rawDate) {
    let dateRange = cloneDeep(state.dateRange)
    let startYear = parseInt(state.helpers.startYear)

    for (let i = 0; i < rawDate.length; i++) {
      let y = rawDate[i].year - startYear
      let m = rawDate[i].month - 1

      dateRange[y].disabled = false
      dateRange[y].children[m].disabled = false

      // if (i === (rawDate.length - 1)) {
      //   commit('setDate', {
      //     year: rawDate[i].year.toString(),
      //     month: rawDate[i].month.toString()
      //   })
      // }
    }

    commit('setDateRange', dateRange)
  },

  async fetchDate ({ state, dispatch }) {
    // if (! state.dateRange.length) {
    // }
    await dispatch('setDateRange')

    let level = state.params.level
    let response = await axios.get(`getResource.php?level=${level}`)

    await dispatch('setDateRangeAvailable', response.data.data)
  },

  async fetchResources ({ state, commit }) {
    let level = state.params.level
    let cat = state.params.item
    let year = state.params.year
    let month = state.params.month

    if (level && cat && year && month) {
      let response = await axios.get('getResource.php', {
        params: { level, cat, year, month }
      })

      commit('setTable', {
        table: response.data.data
      })
    }
  },

  // eslint-disable-next-line
  async downloadResource ({ commit }, { id }) {
    return await axios.get(`download.php?id=${id}`)

    // console.log(response.data);
  }
}

const mutations = {
  setDateRange (state, date) {
    state.dateRange = cloneDeep(date)
  },
  setLevel (state, payload) {
    if (isEmpty(payload)) {
      return state.params.level = null
    }
    state.params.level = payload.level
  },
  setDate (state, payload) {
    if (isEmpty(payload)) {
      state.params.year = null
      state.params.month = null
      return
    }
    state.params.year = payload.year
    state.params.month = payload.month
  },
  setItem (state, payload) {
    if (isEmpty(payload)) {
      return state.params.item = null
    }
    state.params.item = payload.item
  },
  setTable (state, payload) {
    if (isEmpty(payload)) {
      return state.table = []
    }
    state.table = payload.table
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
